import { notification, Spin } from "antd";
import requestService from "api/request";
import { region } from "lib/data";
import { handleUploadFile } from "lib/helpers/format";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "store";
import { onSetUser } from "store/app";

const KycPage = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    region: "",
    identity_number: "",
    before_identity_card: null,
    after_identity_card: null,
    first_name: "",
    last_name: "",
  });
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const getUser = async () => {
    try {
      const res = await requestService.get("/profile/me");
      if (res && res.data) {
        dispatch(onSetUser(res?.data?.data));
      }
    } catch (error) {
      console.log("====================================");
      console.log(error);
      console.log("====================================");
      localStorage.clear();
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const before_identity_card = await handleUploadFile(
        form.before_identity_card
      );

      const after_identity_card = await handleUploadFile(
        form.after_identity_card
      );

      const res = await requestService.post("/profile/kyc-profile", {
        data: {
          ...form,
          before_identity_card,
          after_identity_card,
        },
      });
      if (res && res.data) {
        notification.success({
          message: res.data.message,
          duration: 5,
        });
        navigate("/asset");
        getUser();
      }
    } catch (error: any) {
      notification.success({
        message: error?.response?.data?.message || "Netword err",
        duration: 5,
      });
    }
    setLoading(false);
  };

  return (
    <div className="max-w-[1280px]  mx-auto p-5">
        <Spin spinning={loading} fullscreen/>
      <div className="main-box lay-box clearfix">
        <div className="w-full bg-bg">
          <div className="w-1200px py-24px mx-auto box-border air:w-full air:px-24px pad:w-full pad:px-24px phone:w-full phone:px-16px">
            <div className="flex flex-col">
              <div className="mb-[20px] pad:mb-16px phone:mb-16px" />{" "}
              <div className="flex justify-between items-center">
                <span className="text-32px pad:text-20px phone:text-20px font-semibold text-primaryText">
                  {t("Xác minh")}
                </span>{" "}
              </div>
            </div>{" "}
            <div className="flex justify-between mt-32px min-h-396px air:flex-col air:justify-start pad:flex-col pad:justify-start pad:min-h-0 phone:flex-col phone:justify-start phone:min-h-0">
              <div className="w-680px border border-solid border-v3StrengthBorder0 rounded-16px air:w-full pad:w-full phone:w-full !phone:border-0">
                {" "}
                <div className="p-32px phone:p-0">
                  <div id="recharge-guide-1">
                    <div>
                      <div className="flex justify-between items-center mt-40px phone:mt-32px">
                        <div className="flex items-center gap-1">
                          <div className="w-24px h-24px flex justify-center items-center rounded-12px bg-v3PrimaryText text-v3InverseIcon font-semibold phone:hidden">
                            1
                          </div>{" "}
                          <div className="ml-12px text-fs20 font-semibold text-primaryText phone:ml-0 phone:text-fs16">
                            {t("Chọn Quốc Gia")}
                          </div>
                        </div>{" "}
                      </div>{" "}
                      <div className="pl-9 phone:pl-0">
                        <div className="bit-select mt-20px w-full box-border phone:mt-8px bit-select--large">
                          {/**/}
                          <div className="bit-input bit-input--large bit-input--round  bit-input--suffix ">
                            {/**/}
                            {/**/}
                            <select
                              className="bit-input__inner"
                              style={{ height: 48 }}
                              value={form?.region}
                              onChange={(e) =>
                                setForm({ ...form, region: e.target.value })
                              }
                            >
                              <option className="text-[#000] " disabled>
                                {t("Chọn quốc gia")}
                              </option>
                              {region.map((i) => (
                                <option className="text-[#000]" value={i}>
                                  {i}
                                </option>
                              ))}
                            </select>
                          </div>

                          {/**/}
                        </div>{" "}
                        {/**/}
                      </div>
                    </div>
                    <div>
                      <div className="flex justify-between items-center mt-40px phone:mt-32px">
                        <div className="flex items-center gap-1">
                          <div className="w-24px h-24px flex justify-center items-center rounded-12px bg-v3PrimaryText text-v3InverseIcon font-semibold phone:hidden">
                            2
                          </div>{" "}
                          <div className="ml-12px text-fs20 font-semibold text-primaryText phone:ml-0 phone:text-fs16">
                            {t("Số Chứng minh thư/Hộ chiếu")}
                          </div>
                        </div>{" "}
                      </div>{" "}
                      <div className="pl-9 phone:pl-0">
                        <div className="bit-select mt-20px w-full box-border phone:mt-8px bit-select--large">
                          {/**/}
                          <div className="bit-input bit-input--large bit-input--round  bit-input--suffix ">
                            {/**/}
                            {/**/}
                            <input
                              placeholder={t("Số chứng minh thư/Hộ chiếu")}
                              data-testid="RechargeChainSelect"
                              className="bit-input__inner"
                              style={{ height: 48 }}
                              onChange={(e) =>
                                setForm({
                                  ...form,
                                  identity_number: e.target.value,
                                })
                              }
                            ></input>
                          </div>

                          {/**/}
                        </div>{" "}
                        {/**/}
                      </div>
                    </div>
                    <div>
                      <div className="flex justify-between items-center mt-40px phone:mt-32px">
                        <div className="flex items-center gap-1">
                          <div className="w-24px h-24px flex justify-center items-center rounded-12px bg-v3PrimaryText text-v3InverseIcon font-semibold phone:hidden">
                            3
                          </div>{" "}
                          <div className="ml-12px text-fs20 font-semibold text-primaryText phone:ml-0 phone:text-fs16">
                            {t("Upload thông tin")}
                          </div>
                        </div>{" "}
                      </div>{" "}
                      <div className="pl-9 phone:pl-0">
                        <div className="text-[#fff] my-4 pl-9">
                          * {t("Ảnh mặt trước")}
                        </div>
                        <div className="bit-select mt-20px w-full box-border phone:mt-8px bit-select--large">
                          {/**/}
                          <div className="bit-input bit-input--large bit-input--round  bit-input--suffix">
                            <div className="flex items-center justify-center w-full">
                              <label
                                htmlFor="cc-1"
                                className="flex flex-col items-center justify-center w-full h-64 overflow-hidden border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 "
                              >
                                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                  {form?.before_identity_card ? (
                                    <img
                                      src={URL.createObjectURL(
                                        form?.before_identity_card
                                      )}
                                      alt=""
                                      className="max-w-[150px] ] mx-auto"
                                    />
                                  ) : (
                                    <>
                                      <svg
                                        className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 20 16"
                                      >
                                        <path
                                          stroke="currentColor"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth={2}
                                          d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                                        />
                                      </svg>
                                      <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                                        <span className="font-semibold">
                                          Click to upload
                                        </span>{" "}
                                      </p>
                                    </>
                                  )}
                                </div>
                                <input
                                  id="cc-1"
                                  type="file"
                                  className="hidden"
                                  accept="image/png, image/gif, image/jpeg"
                                  onChange={(e) => {
                                    if (!!e.target.files?.length)
                                      setForm({
                                        ...form,
                                        before_identity_card: e.target.files[0],
                                      } as any);
                                  }}
                                />
                              </label>
                            </div>
                          </div>

                          {/**/}
                        </div>{" "}
                        {/**/}
                      </div>
                      <div className="pl-9 phone:pl-0">
                        <div className="text-[#fff] my-4 pl-9">
                          * {t("Ảnh mặt sau")}
                        </div>
                        <div className="bit-select mt-20px w-full box-border phone:mt-8px bit-select--large">
                          {/**/}
                          <div className="bit-input bit-input--large bit-input--round  bit-input--suffix">
                            <div className="flex items-center justify-center w-full">
                              <label
                                htmlFor="cc-2"
                                className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 overflow-hidden "
                              >
                                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                  {form?.after_identity_card ? (
                                    <img
                                      src={URL.createObjectURL(
                                        form?.after_identity_card
                                      )}
                                      alt=""
                                      className="max-w-[150px] mx-auto "
                                    />
                                  ) : (
                                    <>
                                      <svg
                                        className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 20 16"
                                      >
                                        <path
                                          stroke="currentColor"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth={2}
                                          d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                                        />
                                      </svg>
                                      <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                                        <span className="font-semibold">
                                          Click to upload
                                        </span>{" "}
                                      </p>
                                    </>
                                  )}
                                </div>
                                <input
                                  id="cc-2"
                                  type="file"
                                  className="hidden"
                                  accept="image/png, image/gif, image/jpeg"
                                  onChange={(e) => {
                                    if (!!e.target.files?.length)
                                      setForm({
                                        ...form,
                                        after_identity_card: e.target.files[0],
                                      } as any);
                                  }}
                                />
                              </label>
                            </div>
                          </div>

                          {/**/}
                        </div>{" "}
                        {/**/}
                      </div>
                    </div>

                    <div>
                      <div className="flex justify-between items-center mt-40px phone:mt-32px w-full">
                        <div className="flex items-center w-full">
                          <button
                            type="button"
                            className="bit-button w-full bit-button--chunky bit-button--medium is-round font-[700]"
                            style={{ boxShadow: "0 4px 0 0 undefined" }}
                            data-v-489927de=""
                            data-testid="LoginNowButton"
                            onClick={handleSubmit}
                          >
                            {/**/}
                            {/**/}
                            {/**/}
                            <span>{t("Gửi thông tin")}</span>
                            {/**/}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>{" "}
                  {/**/} {/**/}
                </div>
              </div>{" "}
            </div>{" "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default KycPage;
